<template>
  <div>
    <p>traffic users</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
